export default function EmergencyTiersSection() {
  const tiers = [
    {
      title: "CRITICAL",
      subtitle: "Travel within 72 hours",
      bg: "bg-red-50 border-red-300",
      badge: "bg-red-600",
      badgeText: "Call Immediately",
      description: "Your trip is in 3 days or less. This is the most urgent tier. Call us immediately at 877-253-0084. Same-day document submission is required. Processing time depends on agency availability and what day of the week it is. Be prepared to overnight your documents to us today.",
      processing: "As fast as 24 hours from agency receipt",
      ctaText: "Call Now",
      ctaUrl: "tel:8772530084",
      ctaStyle: "bg-red-600 hover:bg-red-700 text-white",
      icon: "ri-alert-line",
    },
    {
      title: "URGENT",
      subtitle: "Travel within 4–7 days",
      bg: "bg-amber-50 border-amber-300",
      badge: "bg-amber-500",
      badgeText: "Act Today",
      description: "Your trip is within a week. This is very manageable if you act now. Start your order online or call us today. Our 3-business-day processing tier handles most situations in this window.",
      processing: "3 business days from document receipt",
      ctaText: "Start Order",
      ctaUrl: "https://fastpassportcenter.com/checkout/",
      ctaStyle: "bg-amber-500 hover:bg-amber-600 text-white",
      icon: "ri-timer-flash-line",
    },
    {
      title: "EXPEDITED",
      subtitle: "Travel within 8–14 days",
      bg: "bg-teal-50 border-teal-300",
      badge: "bg-teal-600",
      badgeText: "Don't Wait",
      description: "You have a week to two weeks. Don't wait — government processing alone won't make it. Our 4–7 business day tiers work well for this window with time to spare.",
      processing: "4–7 business days from document receipt",
      ctaText: "Start Order",
      ctaUrl: "https://fastpassportcenter.com/checkout/",
      ctaStyle: "bg-teal-600 hover:bg-teal-700 text-white",
      icon: "ri-speed-up-line",
    },
  ];

  return (
    <section id="emergency-tiers" className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-red-500 text-xs font-bold uppercase tracking-[0.2em] mb-3">Urgency Levels</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What <span className="text-red-600">Qualifies as a Passport Emergency?</span>
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto">
            Not every urgent situation is the same. Here's how we categorize emergency passport requests and what's realistic for each timeline.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {tiers.map((tier, i) => (
            <div
              key={i}
              className={`${tier.bg} border rounded-lg overflow-hidden flex flex-col`}
            >
              <div className="p-6 md:p-7 flex-1 flex flex-col">
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-11 h-11 rounded-full ${tier.badge} flex items-center justify-center`}>
                    <i className={`${tier.icon} text-white text-lg`}></i>
                  </div>
                  <div>
                    <span className={`text-xs font-bold uppercase ${tier.badge} text-white px-2 py-0.5 rounded`}>
                      {tier.badgeText}
                    </span>
                    <h3 className="font-serif text-xl font-bold text-[#1A365D] mt-1">{tier.title}</h3>
                  </div>
                </div>
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">{tier.subtitle}</p>
                <p className="text-gray-600 text-sm leading-relaxed mb-4 flex-1">{tier.description}</p>
                <div className="bg-white/70 rounded-md p-3 mb-4">
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Processing</p>
                  <p className="text-sm font-bold text-[#1A365D]">{tier.processing}</p>
                </div>
                <a
                  href={tier.ctaUrl}
                  className={`inline-flex items-center justify-center gap-2 font-bold text-sm px-6 py-3 rounded-md transition-all hover:scale-105 whitespace-nowrap ${tier.ctaStyle}`}
                >
                  <i className={`${i === 0 ? "ri-phone-line" : "ri-arrow-right-line"}`}></i>
                  {tier.ctaText}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}